import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Swords } from "lucide-react";

// Card shown on the BendyWheels main menu that leads into the Skate Rank app.
// Uses the yellow accent + red PRO glow to hint at the streetwear aesthetic
// while staying within the BendyWheels palette.
export const SkateEntryCard = ({ onEnter }) => {
  return (
    <motion.button
      type="button"
      onClick={onEnter}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: "spring", stiffness: 300, damping: 22 }}
      className="relative w-full max-w-md p-3 sm:p-4 flex items-center gap-3 sm:gap-4 group text-left"
      style={{
        backgroundColor: "#0d0d0d",
        border: "1px solid #FFD400",
        borderRadius: 4,
        boxShadow: "0 0 24px rgba(255, 212, 0, 0.12)",
      }}
      data-testid="skate-entry-card"
    >
      {/* Corner brackets */}
      <span aria-hidden className="absolute -top-px -left-px w-3 h-3 border-t-2 border-l-2" style={{ borderColor: "#FFD400" }} />
      <span aria-hidden className="absolute -top-px -right-px w-3 h-3 border-t-2 border-r-2" style={{ borderColor: "#FFD400" }} />
      <span aria-hidden className="absolute -bottom-px -left-px w-3 h-3 border-b-2 border-l-2" style={{ borderColor: "#FFD400" }} />
      <span aria-hidden className="absolute -bottom-px -right-px w-3 h-3 border-b-2 border-r-2" style={{ borderColor: "#FFD400" }} />

      <div
        className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center"
        style={{ backgroundColor: "#FFD400", borderRadius: 2 }}
      >
        <Swords size={22} color="#111" strokeWidth={2.5} />
      </div>

      <div className="flex-1 min-w-0">
        <div
          className="text-[9px] sm:text-[10px] uppercase tracking-[0.3em] sm:tracking-[0.35em] text-white/60 leading-none"
          style={{ fontFamily: "Orbitron, sans-serif" }}
        >
          Bonus Mode
        </div>
        <div
          className="text-base sm:text-lg md:text-xl font-black uppercase tracking-widest text-white mt-1 leading-tight"
          style={{ fontFamily: "Orbitron, sans-serif" }}
        >
          Skate Rank
        </div>
        <div className="text-[11px] sm:text-xs text-white/50 mt-0.5 sm:mt-1 line-clamp-1">
          1v1 challenges · ELO · Bronze → Pro
        </div>
      </div>

      <ArrowRight
        size={18}
        color="#FFD400"
        className="flex-shrink-0 transition-transform group-hover:translate-x-1"
      />
    </motion.button>
  );
};

export default SkateEntryCard;
